import { EnumArray, EnumArrayObj } from '@xhgj/xh-jsutils'
import { filterApiData } from '../../components/SearchFilter/TemplateData'

export type SearchItem = {
  code: string
  name: string
  id: string
}
interface SearchListOptions<T = any> {
  filterFn?: (item: T) => boolean
  codeKey?: keyof T
  idKey?: keyof T
  nameKey?: keyof T
}

export class CustomEnumArray<
  T extends readonly EnumArrayObj[],
> extends EnumArray<T> {
  toSearchList(options?: SearchListOptions<T[number]>) {
    const { filterFn } = options || {}
    const codeKey = (options?.codeKey ??
      ('value' as keyof T[number])) as keyof T[number]
    const idKey = (options?.idKey ?? codeKey) as keyof T[number]
    const nameKey = (options?.nameKey ??
      ('label' as keyof T[number])) as keyof T[number]
    const pickStr = (item: T[number], key: keyof T[number]) =>
      String((item as any)[key])
    if (filterFn) {
      return (
        this.filter(filterFn)?.map((item) => {
          return {
            code: pickStr(item, codeKey),
            name: pickStr(item, nameKey),
            id: pickStr(item, idKey),
          }
        }) ?? []
      )
    }
    return this.map((item) => {
      return {
        code: pickStr(item, codeKey),
        name: pickStr(item, nameKey),
        id: pickStr(item, idKey),
      }
    })
  }

  toSearchListFn(options?: SearchListOptions<T[number]>) {
    return (page?: string, str?: string) => {
      const list = this.toSearchList(options)
      return filterApiData(list, str, page)
    }
  }
  toAllLabelSearchListFn() {
    return (page?: string, str?: string) => {
      const list = this.map((item) => {
        return {
          code: item.label + '',
          name: item.label,
          id: item.label + '',
        }
      })
      return filterApiData(list, str, page)
    }
  }
  toDropDownList() {
    return this.getKeyMappedList({
      value: 'key',
    })
  }
}

export function customCreateEnum<T extends readonly EnumArrayObj[]>(
  enumsTuple: T,
) {
  return new CustomEnumArray(enumsTuple)
  // return Object.freeze(new CustomEnumArray(enumsTuple))
}
import { EnumArray, EnumArrayObj } from '@xhgj/xh-jsutils'
import { filterApiData } from '../../components/SearchFilter/TemplateData'

export type SearchItem = {
  code: string
  name: string
  id: string
}
interface SearchListOptions<T = any> {
  filterFn?: (item: T) => boolean
  codeKey?: keyof T
  idKey?: keyof T
  nameKey?: keyof T
}

export class CustomEnumArray<
  T extends readonly EnumArrayObj[],
> extends EnumArray<T> {
  toSearchList(options?: SearchListOptions<T[number]>) {
    const { filterFn } = options || {}
    const codeKey = (options?.codeKey ??
      ('value' as keyof T[number])) as keyof T[number]
    const idKey = (options?.idKey ?? codeKey) as keyof T[number]
    const nameKey = (options?.nameKey ??
      ('label' as keyof T[number])) as keyof T[number]
    const pickStr = (item: T[number], key: keyof T[number]) =>
      String((item as any)[key])
    if (filterFn) {
      return (
        this.filter(filterFn)?.map((item) => {
          return {
            code: pickStr(item, codeKey),
            name: pickStr(item, nameKey),
            id: pickStr(item, idKey),
          }
        }) ?? []
      )
    }
    return this.map((item) => {
      return {
        code: pickStr(item, codeKey),
        name: pickStr(item, nameKey),
        id: pickStr(item, idKey),
      }
    })
  }

  toSearchListFn(options?: SearchListOptions<T[number]>) {
    return (page?: string, str?: string) => {
      const list = this.toSearchList(options)
      return filterApiData(list, str, page)
    }
  }
  toAllLabelSearchListFn() {
    return (page?: string, str?: string) => {
      const list = this.map((item) => {
        return {
          code: item.label + '',
          name: item.label,
          id: item.label + '',
        }
      })
      return filterApiData(list, str, page)
    }
  }
  toDropDownList() {
    return this.getKeyMappedList({
      value: 'key',
    })
  }
}

export function customCreateEnum<T extends readonly EnumArrayObj[]>(
  enumsTuple: T,
) {
  return new CustomEnumArray(enumsTuple)
  // return Object.freeze(new CustomEnumArray(enumsTuple))
}
